import { render, staticRenderFns } from "./pogs-list__item--cases.vue?vue&type=template&id=bdf86dfc&scoped=true&"
import script from "./pogs-list__item--cases.vue?vue&type=script&lang=js&"
export * from "./pogs-list__item--cases.vue?vue&type=script&lang=js&"
import style0 from "./pogs-list__item--cases.vue?vue&type=style&index=0&id=bdf86dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf86dfc",
  null
  
)

export default component.exports